"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.classes = void 0;
var classes = {
  inputJsonMainContainer: 'input-json-main-container'
};
exports.classes = classes;